import ArticleLayout from '@/components/feature/ArticleLayout';
import { articoloCategorie } from '@/mocks/articles';

export default function CategoriePage() {
  return <ArticleLayout article={articoloCategorie} />;
}